module.exports = __webpack_public_path__ + "static/img/play-white.a0e3207b.png";